import type {ButtonVariant} from 'shells/button/types';

import type {PrimaryButtonType} from './sidebar-header';

export function getHeaderPrimaryButtonVariant(type: PrimaryButtonType): ButtonVariant {
    switch (type) {
        case 'primary':
            return 'text-primary';
        case 'secondary':
            return 'text-secondary';
        default:
            return 'text-primary';
    }
}
